import styled from 'styled-components'

export const TFoot = styled.tfoot(({ theme }) => ({
  'tr td': {
    backgroundColor: theme.colors.base_5,
  },
}))
